<template>
  <v-form v-model="formValid" ref="form">
    <v-tabs v-model="tab" height="40">
      <v-tab>Company details</v-tab>
      <v-tab>Company logo</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-container class="pa-0">
        <v-tab-item>
          <contractor-details-form
            :data="item"
            @update:data="updateData"
          ></contractor-details-form>
        </v-tab-item>
        <v-tab-item>
          <image-upload
            @removeImage="imageToRemove"
            :imageURL.sync="item.logoURL"
            :imagePreview.sync="imagePreview"
          >
          </image-upload>
        </v-tab-item>
      </v-container>
    </v-tabs-items>
  </v-form>
</template>

<script>
import ContractorDetailsForm from './components/ContractorDetailsForm'
import ImageUpload from '@/components/ImageUpload.vue'
export default {
  name: 'NewContractorView',
  components: {
    ImageUpload,
    ContractorDetailsForm,
  },
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    extraData: {
      type: Object,
      default: () => ({ imagePreview: {} }),
    },
  },
  data: () => ({
    formValid: false,
    tab: 0,
    imagePreview: {},
  }),
  computed: {
    item() {
      return this.editedItem
    },
  },
  watch: {
    formValid(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('formStateChange', newValue)
      }
    },
    imagePreview(newValue) {
      this.extraData.imagePreview = newValue
    },
  },
  methods: {
    imageToRemove(url) {
      this.extraData.imageToRemove = url
    },
    updateData(newVal) {
      for (let k in newVal) {
        this.editedItem[k] = newVal[k]
      }
    },
  },
}
</script>